"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queries = void 0;
exports.queries = {
    vAb0: {
        interpretation: {
            vocab: "basic_health",
            code: "ab0"
        }
    },
    vRh: {
        interpretation: {
            vocab: "basic_health",
            code: "rh"
        }
    },
    weight: {
        interpretation: {
            vocab: "basic_health",
            code: "weight"
        }
    },
    height: {
        interpretation: {
            vocab: "basic_health",
            code: "height"
        }
    },
    bmi: {
        interpretation: {
            vocab: "basic_health",
            code: "bmi"
        },
        limit: Infinity
    },
    patientStatus: {
        interpretation: {
            vocab: "basic_health",
            code: "patient_status"
        }
    },
    signedStatementOfConsent: {
        interpretation: {
            vocab: "basic_health",
            code: "signed_statement_of_consent"
        }
    },
    ekg: {
        interpretation: {
            vocab: "basic_health",
            code: "ecg_procedure"
        }
    },
    heartFailureMedicalTherapy: {
        interpretation: {
            vocab: "basic_health",
            code: "heart_failure_medical_therapy"
        }
    },
    fvs: {
        interpretation: {
            vocab: "basic_health",
            code: "fvs"
        }
    },
    haemoglobin: {
        interpretation: {
            vocab: "basic_health",
            code: "haemoglobin"
        }
    },
    got: {
        interpretation: {
            vocab: "basic_health",
            code: "got"
        }
    },
    gpt: {
        interpretation: {
            vocab: "basic_health",
            code: "gpt"
        }
    },
    ggt: {
        interpretation: {
            vocab: "basic_health",
            code: "ggt"
        }
    },
    serumGlucose: {
        interpretation: {
            vocab: "basic_health",
            code: "serum_glucose"
        }
    },
    smoking: {
        interpretation: {
            vocab: "basic_health",
            code: "smoking"
        }
    },
    currentAlcoholUse: {
        interpretation: {
            vocab: "basic_health",
            code: "current_alcohol_use"
        }
    },
    currentAlcoholAbuse: {
        interpretation: {
            vocab: "basic_health",
            code: "current_alcohol_abuse"
        }
    },
    anamnesticAlcoholAbuse: {
        interpretation: {
            vocab: "basic_health",
            code: "anamnestic_alcohol_abuse"
        }
    },
    summaryOfAlcoholUse: {
        interpretation: {
            vocab: "basic_health",
            code: "summary_of_alcohol_use"
        }
    },
    mentalHealthReview: {
        interpretation: {
            vocab: "basic_health",
            code: "mental_health_review"
        }
    },
    socialWorkerReview: {
        interpretation: {
            vocab: "basic_health",
            code: "social_worker_review"
        }
    },
    // TODO: delete
    complex: {
        tags: [
            {
                vocab: "basic_health",
                code: "complex_choice_item"
            }
        ],
        limit: Infinity
    }
};
